/**
 * Service: customFieldsApi
 */
angular.module('acme.common.service.customFieldsApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('CustomFieldsApiService', ['$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/tenant/settings/custom/fields';
        return this;
      },

      list: function(props) {
        var av = new ApiVersionFactory(),
            q = '';
        
        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + q, version: 'v2' })
        });
      },

      create: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: props
        });
      },
      
      update: function (props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'put',
          url: av.init({ url: this.service + '/' + props.ndx, version: 'v2' }),
          data: props
        });
      },

      forms: {

        service: '',

        list: function(props) {
          var av = new ApiVersionFactory(),
            q = '';

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + q, version: 'v2' })
          });
        },

        create: function(props) {
          return $http({
            method: 'post',
            url: this.service,
            data: props
          });
        },

        update: function (props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service + '/' + props.ndx, version: 'v2' }),
            data: props
          });
        }

      }

    };

}]);